import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';

import ForgotPassword  from 'src/sections/auth/forgot-password';

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {`Forgot Password - ${CONFIG.appName}`}</title>
      </Helmet>

      <ForgotPassword />
    </>
  );
}